import React, { useEffect, useState } from "react";
import { Avatar, Typography, Badge, Button } from "antd";
import { FormattedMessage } from "react-intl";
import { getAgeByDate } from "../../../components/util/helpers";
import { useLocation, useHistory } from "react-router-dom";
import { listBranches } from "../../../api/server";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { usePermission } from "../../../hooks/accessControl";

const { Title, Text } = Typography;

const Header = (props) => {
  const { record, branchId, showActiveBranchWarning } = props;
  const intl = useIntl();
  const scopePrefix = useSelector((state) => state.user.scopePrefix);
  const [branchesList, setBranchesList] = useState([]);
  const [branch, setBranch] = useState(null);
  const letter = record && record.first_name ? record.first_name.charAt(0) : "";
  let location = useLocation();
  let history = useHistory();
  const isAdmin = location.pathname.includes("admin");
  const route = record.status_id === 3 ? "crm_patients" : "patients";
  const hasPermission = usePermission(branchId, route, "viewer");
  const onRedirect = () => {
    const scope = isAdmin ? "admin" : `branches/${branchId}`;
    const url = `../../../${scope}/${route}/${record.id}`;
    history.push(url);
  };

  useEffect(() => {
    getBranches();
  }, []);

  const getBranches = async () => {
    const { data } = await listBranches(
      {
        current: 1,
        pageSize: 100,
      },
      scopePrefix
    );
    setBranchesList(data.items);
  };

  useEffect(() => {
    const filtered = branchesList.filter((i) => i.id === +record.branch)[0];
    if (filtered) {
      setBranch(filtered);
    }
  }, [branchId, branchesList]);

  const statusData = [
    {
      value: 1,
      name: <FormattedMessage id="app.forms.active" />,
      status: "success",
    },
    {
      value: 2,
      name: <FormattedMessage id="app.forms.not_active" />,
      status: "error",
    },
    {
      value: 3,
      name: <FormattedMessage id="app.forms.candidate" />,
      status: "processing",
    },
    {
      value: 4,
      name: <FormattedMessage id="app.forms.pre" />,
      status: "warning",
    },
  ];

  const status =
    record && record.status_id
      ? statusData[record.status_id - 1]["status"]
      : null;
  const statusName =
    record && record.status_id ? statusData[record.status_id - 1]["name"] : "";
  const employeeAge =
    record && record.birthday ? getAgeByDate(record.birthday) : null;
  const arr = [`${record.surename} ${record.first_name}`];
  if (employeeAge) {
    arr.push(employeeAge);
  }
  const name = record ? arr.join(", ") : "";

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "flex-end",
        }}
      >
        <div className="header_container">
          {record && record.avatar_url ? (
            <Avatar className="avatar" src={record.avatar_url} />
          ) : (
            <Avatar
              className="avatar"
              style={{ color: "#f56a00", backgroundColor: "#fde3cf" }}
            >
              {letter}
            </Avatar>
          )}
          <div className="spacer" />
          <div className="header_details_container">
            <Title level={1}>{name}</Title>
            <Badge className="status_badge" status={status} text={statusName} />
          </div>
        </div>
        {hasPermission && (record.branch === +branchId || isAdmin) ? (
          <Button type="primary" onClick={onRedirect}>
            <FormattedMessage id="app.forms.patient.redirect_to_patient" />
          </Button>
        ) : (
          <Text style={{ color: "red" }}>
            {intl.formatMessage({
              id: "app.forms.patient.patientWithIdExist",
            })}
          </Text>
        )}
      </div>
      {showActiveBranchWarning && branch && branch.id !== +branchId && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 0",
          }}
        >
          <Text style={{ color: "red" }}>{`${intl.formatMessage({
            id: "app.forms.patient.patientExist1",
          })}${branch.name}`}</Text>
          <Text>
            {intl.formatMessage({
              id: "app.forms.patient.patientExist2",
            })}
          </Text>
        </div>
      )}
    </div>
  );
};

export default Header;
